export * from './narrative';

import { all, call, spawn } from 'redux-saga/effects';

import narrativeSaga from './narrative';
import getPublicationStatusSaga from './publicationStatus';
import setSubtitleSaga from './subtitle';

function* rootSaga() {
  const sagas = [narrativeSaga, getPublicationStatusSaga, setSubtitleSaga];

  yield all(
    sagas.map(saga =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.error(e);
          }
        }
      }),
    ),
  );
}

export default rootSaga;
